import { Grid } from "@mui/material";
import { FC } from "react";
import { useGetListQuery } from "../../../../features/api/Api";
import { ITCIdentityInput } from "../../../../interfaces/Contact";
import useLocales from "../../../../hooks/useLocales";
import {
  genderOptions,
  isExists,
  locale,
  onlyLetterKey,
  onlyNumberKey,
  params,
  socialStatusOptions,
} from "../../../../utils";
import {
  AutocompleteDropDown,
  DateInput,
  RadioInput,
  ReferenceDropDown,
  TextInput,
} from "../../../../components";
import { useField, useFormikContext } from "formik";

const TCIdentityInput: FC<ITCIdentityInput> = ({
  identityCardTypeId,
  fatherName,
  motherName,
  placeOfBirth,
  socialStatusId,
  serialNo,
  documentNo,
  familyOrdernumber,
  orderNo,
  motherMaidenName,
  volumeNo,
  genderId,
  identityProvince,
  identityTown,
  issuedBy,
  dateOfIssue,
}) => {
  const { values }: any = useFormikContext();
  const { translate } = useLocales();
  const [provinceField] = useField(identityProvince);

  const { data: identityCardTypes } = useGetListQuery<any>({
    resource: "fixity/customer/identityCardType",
    params: params,
  });

  let cardTypeName;
  if (!isExists(identityCardTypes?.data) || !isExists(identityCardTypeId)) {
    return null;
  }

  cardTypeName = identityCardTypes.data.find(
    (item: any) => item.id === identityCardTypeId
  )?.name;

  if (cardTypeName === "tc_identity") {
    return (
      <>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={fatherName}
            label={translate("resources.customers.related_persons.father_name")}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={motherName}
            label={translate("resources.customers.related_persons.mother_name")}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={placeOfBirth}
            label={translate(
              "resources.customers.related_persons.place_of_birth"
            )}
            onKeyPressCapture={(event: any) => onlyLetterKey(event)}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <AutocompleteDropDown
            name={socialStatusId}
            label={translate(
              "resources.customers.related_persons.socialStatuses"
            )}
            options={locale(
              socialStatusOptions,
              "resources.customers.related_persons."
            )}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={serialNo}
            label={translate(
              "resources.customers.related_persons.identity_serial_no"
            )}
            disabled={values.isExistCustomer}
            // onKeyPressCapture={(event: any) => onlyNumberKey(event)}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={documentNo}
            label={translate(
              "resources.customers.related_persons.identity_document_no"
            )}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={familyOrdernumber}
            label={translate(
              "resources.customers.related_persons.identityFamilyOrderNo"
            )}
            onKeyPressCapture={(event: any) => onlyNumberKey(event)}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={orderNo}
            label={translate(
              "resources.customers.related_persons.identityOrderNo"
            )}
            onKeyPressCapture={(event: any) => onlyNumberKey(event)}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={motherMaidenName}
            label={translate(
              "resources.customers.related_persons.motherMaidenName"
            )}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={volumeNo}
            label={translate(
              "resources.customers.related_persons.identityVolumeNo"
            )}
            onKeyPressCapture={(event: any) => onlyNumberKey(event)}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <ReferenceDropDown
            name={identityProvince}
            label={translate(
              "resources.customers.related_persons.identity_province"
            )}
            reference="fixity/setting/TurkTelekomAddress/get-cities/187cf1ae-023f-ed11-a5f4-005056a2cd35"
            optionName="name"
            optionId="turkTelekomId"
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <ReferenceDropDown
            name={identityTown}
            label={translate(
              "resources.customers.related_persons.identity_town"
            )}
            reference={`fixity/setting/TurkTelekomAddress/get-towns-by-city-id`}
            query={{ cityId: provinceField.value }}
            optionName="name"
            optionId="turkTelekomId"
            disabled={!isExists(provinceField.value)}
            skip={!isExists(provinceField.value)}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <TextInput
            name={issuedBy}
            label={translate("resources.customers.related_persons.issuedBy")}
            disabled={values.isExistCustomer}
          />
        </Grid>
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <DateInput
            name={dateOfIssue}
            label={translate("resources.customers.related_persons.dateOfIssue")}
            maxDate={new Date()}
            disabled={values.isExistCustomer}
          />
        </Grid>

        <Grid item md={6} lg={6} xs={12} sm={12}>
          <RadioInput
            name={genderId}
            label={translate("resources.customers.related_persons.gender")}
            radioGroup={locale(
              genderOptions,
              "resources.customers.related_persons."
            )}
            disabled={values.isExistCustomer}
          />
        </Grid>
      </>
    );
  }
  return null;
};

export default TCIdentityInput;
